import { z } from "zod";

/**
 * Self-service password change (authenticated users only).
 */
export const AuthChangePasswordInput = z.object({
  currentPassword: z.string().min(1),
  newPassword: z.string().min(12),
});
export type AuthChangePasswordInput = z.infer<typeof AuthChangePasswordInput>;

/**
 * Forgot password: initial email submission (public, unauthenticated).
 */
export const AuthForgotPasswordInput = z.object({
  email: z.string().email(),
});
export type AuthForgotPasswordInput = z.infer<typeof AuthForgotPasswordInput>;

/**
 * Forgot password: confirm code + new password (public, unauthenticated).
 */
export const AuthConfirmForgotPasswordInput = z.object({
  email: z.string().email(),
  confirmationCode: z.string().min(1),
  newPassword: z.string().min(12),
});
export type AuthConfirmForgotPasswordInput = z.infer<typeof AuthConfirmForgotPasswordInput>;
